module.exports = __webpack_public_path__ + "media/04 Happy Xmas.33d877d1.mp3";